export const commonData = {
  legal_effective_date_TC: `October 2025`,
  legal_effective_date_TC_es: `Octubre de 2025`,
  contact_hours: `Mon-Fri 5am - 7pm PT`,
  contact_hours_es: `Lun-Vie, de 5:00 h a 19:00 h PT`,
  country_name: `United States of America`,
  country_name_es: `Estados Unidos de América`,
};
